import { render } from "./personal.vue?vue&type=template&id=a704448e&scoped=true"
import script from "./personal.vue?vue&type=script&lang=js"
export * from "./personal.vue?vue&type=script&lang=js"

import "./personal.vue?vue&type=style&index=0&id=a704448e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a704448e"]])

export default __exports__